import React, { Component } from 'react';
import { BrowserRouter, Route, Switch } from 'react-router-dom';
 
import HomePage from './components/HomePage';
import DancePage from './components/DancePage';
import DanceInPinkPage from './components/DanceInPinkPage';
import DanceInDarkPage from './components/DanceInDarkPage';
import DanceOnSnowPage from './components/DanceOnSnowPage';
import TasteBudsDancePage from './components/TasteBudsDancePage';
import AboutUsPage from './components/AboutUsPage';
import NoPageFound from './components/NoPageFound';
import Navbar from './components/Navbar';
 
class App extends Component {
  render() {
    return (      
       <BrowserRouter>
        <div>
          <Navbar />
            <Switch>
              <Route path="/" component={HomePage} exact/>
              <Route path="/dance" component={DancePage}/>
              <Route path="/dance_in_pink" component={DanceInPinkPage}/>
              <Route path="/dance_in_dark" component={DanceInDarkPage}/>
              <Route path="/dance_on_snow" component={DanceOnSnowPage}/>
              <Route path="/taste_buds_dance" component={TasteBudsDancePage}/>
              <Route path="/about_us" component={AboutUsPage}/>
              <Route component={NoPageFound}/>
           </Switch>
        </div> 
      </BrowserRouter>
    );
  }
}
 
export default App;